// src/components/UnitSelectModal.js

import React from 'react';
import { Modal, ListGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './UnitSelectModal.css';

/**
 * UnitSelectModal Component
 * 
 * Displays a modal for selecting which unit to add an action area to
 * when multiple editable units are selected.
 * 
 * @param {boolean} show - Controls modal visibility
 * @param {function} onHide - Callback when modal is closed
 * @param {array} units - Array of unit objects to display
 * @param {function} onSelectUnit - Callback when a unit is selected
 */
const UnitSelectModal = ({ show, onHide, units, onSelectUnit }) => {
    const handleUnitClick = (unitId) => {
        onSelectUnit(unitId);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="unit-select-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Team auswählen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="unit-select-description">
                    Für welches Team möchtest Du ein Handlungsfeld anlegen?
                </p>
                <ListGroup className="unit-select-list">
                    {units.map((unit) => (
                        <ListGroup.Item
                            key={unit.id}
                            action
                            onClick={() => handleUnitClick(unit.id)}
                            className="unit-select-item"
                        >
                            {unit.unit_name}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
        </Modal>
    );
};

UnitSelectModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    units: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            unit_name: PropTypes.string.isRequired,
        })
    ).isRequired,
    onSelectUnit: PropTypes.func.isRequired,
};

export default UnitSelectModal;
